import React from 'react';
import { Field, FieldArray } from 'redux-form';
import { BooleanInput, NumberInput, ReferenceArrayInput, SelectArrayInput } from 'react-admin';
import { createStyles, withStyles } from '@material-ui/core/styles';

import KeyInput from '../../../../Common/Utils/KeyInput';
import PopoverHelp from '../../../../Common/Popovers/Help';

const styles = createStyles({
  dropdown: {
    minWidth: 230
  }
});

type Props = {
  classes: any,
  record: any
};

const RulesTab = (props: Props) => (
  <div>
    <div style={{ display: 'flex', paddingTop: 20 }}>
      <div style={{ flex: 1, paddingRight: 15 }}>
        <Field name="render_markup_in_iframe" source="render_markup_in_iframe" component={BooleanInput} label="Render Markup In IFrame" style={{ width: '210px' }} />
        <Field name="always_loose" source="always_loose" component={BooleanInput} label="Always Loose" style={{ width: '150px' }} />
      </div>

      <div style={{ flex: 1, paddingRight: 15 }}>
        <Field name="render_markup_inline" source="render_markup_inline" component={BooleanInput} label="Render Markup Inline" style={{ width: '200px' }} />
      </div>
    </div>
    <div style={{ display: 'flex' }}>
      <div style={{ flex: 1 }}>
        <div style={{ display: 'inline' }}>
          <Field name="ceiling" source="ceiling" component={NumberInput} label="Ceiling" />
          <PopoverHelp content="Bid price will be below ceiling" /><br />
        </div>

        <Field name="price_scale" source="price_scale" component={NumberInput} label="Price Scale" />
        <PopoverHelp content="Bid price will be multiplied by bid scale" /><br />

        <Field name="blocked_creative_attributes" source="blocked_creative_attributes" component={ReferenceArrayInput} label="Creative Attributes Blocking" resource="campaign_ad_qualities" reference="helpers/creative_attributes" sort={{ field: 'name', order: 'ASC' }} className={props.classes.dropdown} allowEmpty record={props.record} style={{ maxWidth: 250 }}>
          <Field name="blocked_creative_attributes" source="blocked_creative_attributes" label="Blocked Creative Attributes" component={SelectArrayInput} style={{ maxWidth: 250 }} />
        </Field><br /><br />

        <FieldArray name="blocked_creative_ids" baseName="blocked_creative_ids" keyName="id" component={KeyInput} mainLabel="Blocked Creative Ids" keyLabel="Creative ID" addItemLabel="Add Creative ID" /><br />
      </div>
      <div style={{ flex: 1 }}>
        <Field name="floor" source="floor" component={NumberInput} label="Floor" />
        <PopoverHelp content="Bid price will be above floor" /><br />

        <Field name="blocked_advertiser_categories" source="blocked_advertiser_categories" component={ReferenceArrayInput} label="Content Category Blocking" resource="campaign_ad_qualities" reference="helpers/content_categories" sort={{ field: 'name', order: 'ASC' }} className={props.classes.dropdown} allowEmpty record={props.record}>
          <Field name="blocked_advertiser_categories" source="blocked_advertiser_categories" label="Content Category Blocking" component={SelectArrayInput} />
        </Field><br /><br />

        <FieldArray name="blocked_advertiser_domains" baseName="blocked_advertiser_domains" keyName="domain" component={KeyInput} mainLabel="Blocked Advertiser Domains" keyLabel="Domain" addItemLabel="Add Domain" /><br />
      </div>
    </div><br />
  </div>
);

export default withStyles(styles)(RulesTab);



// WEBPACK FOOTER //
// ./src/views/Components/Campaigns/AdQuality/Partials/RulesTab.tsx